import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';
import AuthenticationProviderType from '../../../services/enums/authenticationProviderType';
import { UserEditDialogForm, UserEditFormMode } from '../../../services/enums/users';
import { sort } from '../../../services/utils';
import ScreenLoaderContainer from '../../portal/controls/screenLoaderContainer';
import ErrorDialog from '../../portal/dialogs/errorDialog';
import ImportUserFormContainer from './importUserForm';

@inject('translationsStore', 'directoryUserMappingStore',
     'addEditUserStore', 'authenticationProvidersStore') @observer
export default class DirectoryUserContainer extends Component {
  
    translationsStore = this.props.translationsStore;
    directoryUserMappingStore = this.props.directoryUserMappingStore;
    addEditUserStore = this.props.addEditUserStore;
    authenticationProvidersStore = this.props.authenticationProvidersStore;

    state = {
        showImportUserDialog: false,
        openErrorDialog: false
    };

    componentDidMount() {

        this.resetForm();
        this.initiateDropdown();
    }

    openErrorDialog = () => {

        this.setState({ 
            openErrorDialog: true
        }); 
    }

    closeErrorDialog = () => {

        this.setState({ 
            openErrorDialog: false
        }); 
    }

    initiateDropdown = () => {

        this.directoryUserMappingStore.setDirectories(undefined);

        this.authenticationProvidersStore.getAllAuthenticationProviders()
            .then(() => {

                let directories = this.authenticationProvidersStore.authenticationProviders.filter((s) => {
                    
                    return s.active === true
                        && (s.providerType.toLowerCase() === AuthenticationProviderType.LDAP.toLowerCase()
                        || s.providerType.toLowerCase() === AuthenticationProviderType.Domain.toLowerCase());
                });

                if (directories.length > 0) {
                 
                    directories = sort(directories)('name')('asc');

                    this.directoryUserMappingStore.setSelectedAuthProviderId(directories[0].id);
                    this.directoryUserMappingStore.setDirectories(directories);
                }
            });
    }

    openImportUserDialog = (e) => {

        this.setState({
            showImportUserDialog: true
        });
    }

    closeImportUserDialog = (e) => {
        
        this.setState({
            showImportUserDialog: false
        });
    }

    searchBoxChange = (e) => {

        this.directoryUserMappingStore.setContainsPattern(e.target.value);
    }

    search = (e) => {

        e.preventDefault();

        if (this.directoryUserMappingStore.containsPattern === '') {
            
            return;
        }

        this.directoryUserMappingStore
            .getUserEntries(
                            this.directoryUserMappingStore.selectedProviderId,
                            this.directoryUserMappingStore.containsPattern
                        )
            .catch(() => {

                this.openErrorDialog();
            });
    }

    resetForm = () => {

        this.directoryUserMappingStore.resetForm();
    }

    directoriesChange = (e, index, value) => {

        this.resetForm();
        this.directoryUserMappingStore.setSelectedAuthProviderId(value);
    }

    importUser = (e, user) => {

        this.closeImportUserDialog();

        this.addEditUserStore.reset();

        this.addEditUserStore.setUserName(user.username);
        this.addEditUserStore.setFirstName(user.firstname || user.username);
        this.addEditUserStore.setLastName(user.lastname || user.username);
        this.addEditUserStore.setEmail(user.email || '');
        this.addEditUserStore.setAuthenticationProviderId(this.directoryUserMappingStore.selectedAuthProviderId);
        this.addEditUserStore.setAuthenticationProviderType(this.directoryUserMappingStore.selectedProviderType);
        
        this.resetForm();
        
        this.props.addEditUserStore.setUserEditDialogForm(UserEditDialogForm.add);
    }

    render() {

        const loader = <div style={{
            height: '530px'
        }}>
                <ScreenLoaderContainer />
        </div>

        const directories = this.directoryUserMappingStore.directories;
        const shouldLoaderDisplay = directories && directories.length > 0 ? true : false;

        if (!shouldLoaderDisplay) {
            
            return loader;
        }

        const dialogTranslations = {
            directory: this.props.translationsStore.translate('DIRECTORY'),
            import: this.props.translationsStore.translate('IMPORT'),
            importUsersTitle: this.props.translationsStore.translate('IMPORT_DIRECTORY_USER_DETAILS'),
            searchUsersPlaceHolder: this.directoryUserMappingStore.selectedProviderType.toLowerCase() === AuthenticationProviderType.LDAP.toLowerCase()
                                    ? this.props.translationsStore.translate('SEARCH_LDAP_USERS_PLACEHOLDER') 
                                    : this.props.translationsStore.translate('SEARCH_DOMAIN_USERS_PLACEHOLDER') ,
            selectDirectoryUsersTooltip: this.props.translationsStore.translate('SEARCH_DIRECTORY_USER_TOOLTIP')
        };

        const title = <span>{this.props.translationsStore.translate('ERROR')}</span>;

        return ([<ImportUserFormContainer
                    key={1}
                    open={this.state.showImportUserDialog}
                    directories={directories}
                    translations={dialogTranslations}
                    onChange={this.searchBoxChange}
                    directoriesChange={this.directoriesChange}
                    selectedItem={this.directoryUserMappingStore.selectedAuthProviderId}
                    search={this.search}
                    searchValue={this.directoryUserMappingStore.containsPattern}
                    closeDialog={this.closeImportUserDialog}
                    importUser={this.importUser}
                />,
                <ErrorDialog 
                    key={2}
                    show={this.state.openErrorDialog}
                    onConfirm={this.closeErrorDialog}
                    deleteButtonText={this.props.translationsStore.translate('CLOSE')}
                    closeDeleteDialog={this.closeErrorDialog}
                    titleText={title}
                    contentText={this.directoryUserMappingStore.getUserEntriesErrorMessage} />
            ]
            
        )
    }
}